// Firebase client initialization with safe guards for missing env vars.
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '',
};

function canInitialize(config) {
  return Boolean(config.apiKey && config.projectId && config.appId);
}

let app = null;
try {
  if (canInitialize(firebaseConfig)) {
    app = getApps().length ? getApp() : initializeApp(firebaseConfig);
  } else {
    // Running without Firebase env config; features that depend on Firebase will be no-ops
    // eslint-disable-next-line no-console
    console.warn('Firebase config missing. Auth/Firestore will be disabled until env is set.');
  }
} catch (e) {
  console.error('Failed to initialize Firebase', e);
}

export const auth = app ? getAuth(app) : null;
export const db = app ? getFirestore(app) : null;
export const storage = app ? getStorage(app) : null;
export const googleProvider = app ? new GoogleAuthProvider() : null;


